var createStylesheet = function(chunkId, fullhref, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	2143: 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"36":1,"159":1,"352":1,"387":1,"435":1,"476":1,"701":1,"741":1,"898":1,"975":1,"1241":1,"1374":1,"1407":1,"1500":1,"2009":1,"2118":1,"2404":1,"2426":1,"2503":1,"2541":1,"2570":1,"2691":1,"2875":1,"3141":1,"3566":1,"3615":1,"3623":1,"3646":1,"3879":1,"3960":1,"4072":1,"4090":1,"4207":1,"4293":1,"4678":1,"4886":1,"4898":1,"4906":1,"4948":1,"5061":1,"5067":1,"5104":1,"5185":1,"5215":1,"5218":1,"5282":1,"5333":1,"5436":1,"5463":1,"5531":1,"5585":1,"5694":1,"5746":1,"5850":1,"5939":1,"6016":1,"6100":1,"6112":1,"6338":1,"6414":1,"6559":1,"6710":1,"7129":1,"7318":1,"7383":1,"7439":1,"7562":1,"7596":1,"7602":1,"7726":1,"7814":1,"7870":1,"8033":1,"8114":1,"8249":1,"8334":1,"8337":1,"8607":1,"8623":1,"8687":1,"8691":1,"8718":1,"8770":1,"8908":1,"8961":1,"9057":1,"9081":1,"9324":1,"9525":1,"9771":1,"9797":1,"9808":1,"9877":1,"9888":1,"9914":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr